import { createElement } from 'react';
import AdvancedSearch from '@wh-search/ui';
import { render } from '../../../libs/ngsModuleLoader';
import Translator from '../../Translator';

const ADVANCED_SEARCH_CONTAINER_ID = 'advanced-search-container';

const prepareContainer = () => {
    const existingContainer = document.getElementById(ADVANCED_SEARCH_CONTAINER_ID);

    if (existingContainer) {
        return existingContainer;
    }

    const container = document.createElement('div');
    container.setAttribute('id', ADVANCED_SEARCH_CONTAINER_ID);
    document.body.appendChild(container);

    return container;
};

export const renderAdvancedSearch = () => {
    const locale = Translator.getLocale();
    const jurisdiction = window.whStatic.config.jurisdiction.replace('.','');
    const environment = window.whStatic.config.environment;
    
    render(prepareContainer(), { uiKit: true }, () => {
        return createElement(AdvancedSearch, {
            locale,
            jurisdiction,
            environment,
        });
    });
};
